<!-- Иконка пустого состояния истории маршрутов. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="4"
      width="18"
      height="18"
      rx="2"
      ry="2"
      :stroke="stroke"
      stroke-width="1.5"
    />
    <path d="M16 2V6M8 2V6M3 10H21" :stroke="stroke" stroke-width="1.5" />
  </svg>
</template>

<script>
export default {
  name: "CalendarHistoryIcon",

  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
